//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AlgoliaEditorial from '@/scripts/libs/algolia/editorial'
import { TRACKER_SEARCH_RESULTS_QUERY } from '@/scripts/constants/tracker'
export default {
  name: 'rb-algolia-popular-searches',
  props: {
    facetName: {
      type: String,
      default: '',
    },
    maxNumber: {
      type: Number,
      default: 1,
    },
    threshold: {
      type: Number,
      default: 80,
    },
  },
  data() {
    return {
      TRACKER_SEARCH_RESULTS_QUERY,
      initialized: false,
      trendingFacets: [],
    }
  },
  methods: {
    async onViewportIntersection(e, isIntersecting) {
      if (!this.initialized && isIntersecting) {
        this.initialized = true
        this.trendingFacets = await AlgoliaEditorial.getTrendingFacets({
          facetName: this.facetName,
          maxNumber: this.maxNumber,
          threshold: this.threshold,
        })
      }
    },
  },
}
